import { useEffect } from 'react';
import aos from 'aos';

export default function useAos() {
  useEffect(() => {
    setTimeout(() => {
      aos.init({ disable: 'mobile', once: true, offset: 100 });
    }, 100);
  }, []);
}